import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import Reveal from "./Reveal";

const FEATURES = [
    "12 months of full access to ITF on TradingView",
    "Works on most liquid markets — indices, ETFs, stocks, commodity ETFs",
    "Purpose-built for intraday precision on the 5-minute chart",
    "Instant direction-change visuals included",
    "Step-by-step installation guide — set up in minutes",
    "All updates and improvements during your year",
    "Direct email support at support@getitf.xyz",
];

export default function Pricing() {
    return (
        <section id="pricing" className="relative bg-white py-20 sm:py-28 lg:py-32" data-testid="pricing-section">
            <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <div className="mx-auto max-w-2xl text-center">
                        <p className="font-mono text-xs font-semibold uppercase tracking-[0.24em] text-emerald-700">Pricing</p>
                        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
                            One plan. One honest price.
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
                            Everything ITF does, for less than the cost of one bad trade. $275 USD for 12 months of access.
                        </p>
                    </div>
                </Reveal>

                <Reveal delay={0.12}>
                    <div className="chart-card-shadow mx-auto mt-14 grid max-w-4xl grid-cols-1 overflow-hidden rounded-3xl border border-slate-200/80 bg-white md:grid-cols-2">
                        <div className="relative flex flex-col justify-center overflow-hidden bg-slate-900 p-9 text-white sm:p-11">
                            <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-emerald-500/20 blur-3xl" />
                            <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-400">ITF Annual</p>
                            <div className="mt-5 flex items-end gap-2">
                                <span className="font-display text-6xl font-extrabold tracking-tight sm:text-7xl">$275</span>
                                <span className="pb-2.5 text-sm font-medium text-slate-400">/ 12 months</span>
                            </div>
                            <div className="mt-6 flex flex-wrap gap-2">
                                <span className="rounded-full border border-white/15 bg-white/5 px-3 py-1 font-mono text-[11px] font-semibold text-slate-300">
                                    $22.92 / month
                                </span>
                                <span className="rounded-full border border-white/15 bg-white/5 px-3 py-1 font-mono text-[11px] font-semibold text-slate-300">
                                    $0.75 / day
                                </span>
                                <span className="rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 font-mono text-[11px] font-semibold text-emerald-300">
                                    One payment
                                </span>
                            </div>
                            <p className="mt-6 text-sm leading-relaxed text-slate-400">
                                No auto-renewal. No hidden fees. No subscription traps — you pay once and stay in control.
                            </p>
                        </div>

                        <div className="flex flex-col justify-center p-9 sm:p-11">
                            <ul className="space-y-3.5">
                                {FEATURES.map((f) => (
                                    <li key={f} className="flex items-start gap-3 text-sm leading-relaxed text-slate-700">
                                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                                            <Check className="h-3 w-3" strokeWidth={3} />
                                        </span>
                                        {f}
                                    </li>
                                ))}
                            </ul>
                            <Link
                                to="/checkout"
                                data-testid="pricing-subscribe-button"
                                className="group mt-8 flex items-center justify-center gap-2 rounded-full bg-emerald-600 px-7 py-4 text-base font-semibold text-white shadow-lg shadow-emerald-600/25 transition-all duration-200 hover:scale-[1.02] hover:bg-emerald-700 active:scale-[0.98]"
                            >
                                Get ITF Access — $275/year
                                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                            </Link>
                            <p className="mt-3.5 text-center font-mono text-[10px] uppercase tracking-[0.16em] text-slate-400">
                                Secure checkout by Dodo Payments · Access activated after verification
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
